const qs = require('qs')

export function getParams(search) {
  if (!search) {
    return {}
  }

  return qs.parse(search.substring(1))
}

export function urlChanged(props, prevProps, any = false) {
  const curParams = getParams(props.location.search)
  const prevParams = getParams(prevProps.location.search)

  if (
    curParams.page !== prevParams.page ||
    curParams.sort !== prevParams.sort ||
    curParams.query !== prevParams.query ||
    props.location.pathname !== prevProps.location.pathname
  ) {
    return true
  }

  if (any) {
    return (
      props.location.pathname !== prevProps.location.pathname ||
      props.location.search !== prevProps.location.search
    )
  }

  return false
}

export function queryToParams(search, filter = null) {
  if (!search || search === '') {
    return {}
  }

  if (search.substring(0, 1) === '?') {
    search = search.substring(1)
  }

  let values = JSON.parse(
    '{"' + decodeURI(search.replace(/&/g, '","').replace(/=/g, '":"')) + '"}'
  )
  if (filter) {
    values = Object.keys(values)
      .filter(key => key.includes(filter))
      .reduce((obj, key) => {
        obj[key] = values[key]
        return obj
      }, {})
  }

  return values
}
